import { newSpecPage } from '@stencil/core/testing';
import { NylasCalendarPicker } from '../nylas-calendar-picker';
import { MultiSelectDropdown } from '../../../design-system/multi-select-dropdown/multi-select-dropdown';
import { h } from '@stencil/core';
import { Calendar } from '@nylas/core';

const calendars: Calendar[] = [
  {
    id: 'new-calendar-id',
    name: 'New Calendar',
    grant_id: 'new-grant-id',
    hex_color: '#000000',
    hex_foreground_color: '#FFFFFF',
    is_primary: false,
    is_owned_by_user: true,
    read_only: false,
    timezone: 'America/Toronto',
    object: 'calendar',
  },
  {
    id: 'another-new-calendar-id',
    name: 'Another New Calendar',
    grant_id: 'new-grant-id',
    hex_color: '#000000',
    hex_foreground_color: '#FFFFFF',
    is_primary: false,
    is_owned_by_user: true,
    read_only: false,
    timezone: 'America/Toronto',
    object: 'calendar',
  },
];

describe('nylas-calendar-picker', () => {
  let nylasCalendarPicker: NylasCalendarPicker;
  let multiSelectDropdown: HTMLMultiSelectDropdownElement;
  let page: any;
  beforeEach(async () => {
    page = await newSpecPage({
      components: [NylasCalendarPicker, MultiSelectDropdown],
      template: () => {
        return (
          <nylas-calendar-picker name="calendar" calendars={calendars}>
            <multi-select-dropdown name={'calendar'} label="Only schedule meetings when I'm available on"></multi-select-dropdown>
          </nylas-calendar-picker>
        );
      },
    });
    await page.waitForChanges();
    nylasCalendarPicker = page.rootInstance as NylasCalendarPicker;
    multiSelectDropdown = page.root?.shadowRoot?.querySelector('multi-select-dropdown') as HTMLMultiSelectDropdownElement;
  });

  it('selects calendar', async () => {
    const spyEvent = jest.fn();
    nylasCalendarPicker.valueChanged = {
      emit: spyEvent,
    };
    const mockEvent = new CustomEvent('selectedOptionsChanged', {
      detail: { value: ['new-calendar-id'], name: 'calendar' },
      bubbles: true,
      composed: true,
    });
    nylasCalendarPicker.selectedOptionsChangedHandler(mockEvent);
    expect(spyEvent).toHaveBeenCalled();
  });

  it('closes dropdown on outside click', async () => {
    multiSelectDropdown.shadowRoot?.querySelector('button')?.click();
    await page.waitForChanges();

    expect(multiSelectDropdown.shadowRoot?.querySelector('.dropdown-content')).not.toBeNull();
    const options = multiSelectDropdown.shadowRoot?.querySelectorAll('.dropdown-content ul li');
    expect(options?.length).toBe(2);

    document.body.click();
    await page.waitForChanges();
    expect(multiSelectDropdown.shadowRoot?.querySelector('.dropdown-content')).toBeNull();
  });

  it('updates the list when calendar options are changed', async () => {
    nylasCalendarPicker.calendars = [...calendars, { ...calendars[0], id: 'new-cal-0', name: 'Brand New Calendar' }];
    await page.waitForChanges();
    multiSelectDropdown.shadowRoot?.querySelector('button')?.click();
    await page.waitForChanges();
    expect(page.root).toMatchSnapshot();
    const options = multiSelectDropdown.shadowRoot?.querySelectorAll('.dropdown-content ul li');
    expect(options?.length).toBe(3);
    const option3 = multiSelectDropdown.shadowRoot?.querySelectorAll('.dropdown-content ul li#new-cal-0');
    expect(option3).not.toBeNull();
  });
});
